import React from "react";
import { Chip } from "@mui/material";
import { GridActionsCellItem, GridRowModes } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { getOrderStateBadgeStyles, getOrderStateN2BadgeStyles } from "../utils/orderStateColors";
import Utils from "../../../utils/Utils";
import OrderStates from "../../../utils/OrderStates";
import EtiquetasPedidoN2 from "../components/ui/EtiquetasPedidoN2";
import { ESTADO_PROCESO } from "../../../config/constants";

/**
 * Columnas del DataGrid de pedidos con productos en Nave 2
 */
export const generateSalesN2Columns = ({ getNombreAlmacen, ordersModels, onEditar, onGuardar, onCancelar, onForzar, productosPorPedido = {} }) => [


            {
                field: 'num',
                headerName: 'Número',
                flex: 0.75,
                renderCell: (params) => <a
                    href={'#/pedidosn2/order/' + params.value + '?tipo=' + params.row.type + '&ruta=' + params.row.route}
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                >
                    {params.value}
                </a>
            },
            {
                field: 'type',
                headerName: 'Tipo',
                flex: 0.75,
                renderCell: (params) => Utils.toCapitalize(params.value),
            },
            {
                field: 'date',
                headerName: 'Fecha',
                flex: 0.75,
                renderCell: (params) => Utils.formatDateWithoutHour(params.value),
            },
            {
                field: 'customer',
                headerName: 'Cliente',
                flex: 2,
                renderCell: (params) => Utils.toCapitalize(params.value),
                filterMode: 'client'
            },
            {
                field: 'route',
                headerName: 'Ruta',
                flex: 1,
                renderCell: (params) => Utils.toCapitalize(params.value),
            },
            {
                field: 'transport',
                headerName: 'Transporte',
                flex: 1.5,
                renderCell: (params) => Utils.toCapitalize(params.value),
            },
            {
                field: 'priority',
                headerName: 'Prioridad',
                flex: 1,
                hide: true,
                renderCell: (params) => params.value,
            },
            {
                field: 'preparerN1',
                headerName: 'Prep. nave 1',
                flex: 1,
                hide: true,
                renderCell: (params) => (
                    params.value ? params.value : ESTADO_PROCESO.SIN_PREPARADOR
                )
            },
            {
                field: 'stateN1',
                headerName: 'Estado nave 1',
                flex: 1,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Chip
                            label={OrderStates.getState(params.value)}
                            size="small"
                            sx={getOrderStateBadgeStyles(params.value, { fontSize: 12 })}
                        />
                    );
                }
            },
            {
                field: 'state',
                headerName: 'Estado',
                flex: 1,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Chip
                            label={OrderStates.getStateN2(params.value)}
                            size="small"
                            sx={getOrderStateN2BadgeStyles(params.value, { fontSize: 12 })}
                        />
                    );
                }
            },
            {
                field: 'warehouse',
                headerName: 'Nave',
                flex: 1,
                filterable: false,
                // El guard evita reventar si el contexto aún no ha cargado los almacenes,
                // igual que hace columnsGrupos con esta misma columna
                renderCell: (params) => <>{getNombreAlmacen ? getNombreAlmacen(params.value) : params.value}</>,
            },
            {
                field: 'exclude',
                headerName: 'No preparar',
                type: 'boolean',
                flex: 0.75,
                editable: true,
            },
            {
                field: 'actions',
                type: 'actions',
                headerName: '',
                // Etiquetas (1-2 botones) + editar + forzar
                width: 170,
                cellClassName: 'actions',
                getActions: ({ id, row }) => {
                    const isInEditMode =
                        ordersModels[id]?.mode === GridRowModes.Edit;

                    if (isInEditMode) {
                        return [
                            <GridActionsCellItem
                                icon={<SaveIcon/>}
                                label="Save"
                                sx={{
                                    color: 'primary.main',
                                }}
                                onClick={() => onGuardar(id)}
                            />,
                            <GridActionsCellItem
                                icon={<CancelIcon/>}
                                label="Cancel"
                                className="textPrimary"
                                onClick={() => onCancelar(id)}
                                color="inherit"
                            />,
                        ];
                    }

                    return [
                        <GridActionsCellItem
                            icon={<EditIcon/>}
                            label="Edit"
                            className="textPrimary"
                            onClick={() => onEditar(id)}
                            color="inherit"
                        />,
                        // Sacar de la lista un pedido colgado (opcional: solo si la página lo pide)
                        ...(onForzar ? [
                            <GridActionsCellItem
                                icon={<DoneAllIcon />}
                                label="Forzar preparado"
                                title="Forzar como preparado y quitar de la lista"
                                onClick={() => onForzar(row)}
                                color="inherit"
                            />
                        ] : []),
                        // DECISION: las etiquetas van junto a editar y forzar, no en columna
                        // aparte. La celda de acciones clona cada elemento y le añade onClick,
                        // tabIndex y touchRippleRef; EtiquetasPedidoN2 los ignora (no los pasa
                        // al DOM) y para la propagación del clic él mismo
                        <EtiquetasPedidoN2 pedido={row} productos={productosPorPedido[row.num]} />
                    ];
                },
            },
];
